module.exports = __webpack_public_path__ + "static/media/lightroom-cc.95bd33d3.svg";